import { SET_AMAZING_PROGRESS, RESET_AMAZING_PROGRESS } from '../actions';

const initialState = {};

export default (state = initialState, {type, payload}) => {
    switch (type) {
        case SET_AMAZING_PROGRESS:
            return {
                ...state,
                ...payload,
            };
        case RESET_AMAZING_PROGRESS:
            return initialState;
        default:
            return state;
    }
}